export class Section2ClassificationSystemId {
  private static readonly _values: Section2ClassificationSystemId[] = [];

  static readonly GHS = new Section2ClassificationSystemId('GHS', 'GHS', 'GHS');
  static readonly CLP = new Section2ClassificationSystemId('CLP', 'CLP', 'CLP');
  static readonly HCS = new Section2ClassificationSystemId(
    'HCS',
    'OSHA (HCS)',
    'OSHA (HCS)'
  );
  static readonly JIS = new Section2ClassificationSystemId('JIS', 'JIS', 'JIS');
  static readonly OTHER = new Section2ClassificationSystemId(
    'OTHER',
    'その他',
    'Other'
  );

  private constructor(
    readonly id: string,
    readonly ja: string,
    readonly en: string
  ) {
    Section2ClassificationSystemId._values.push(this);
  }

  static fromId(id: string): Section2ClassificationSystemId {
    return this._values.find((x) => x.id === id) ?? this.OTHER;
  }

  static values(): Section2ClassificationSystemId[] {
    return this._values;
  }
}
